import { render, staticRenderFns } from "./addAttendanceClasses.vue?vue&type=template&id=5fa3a798&scoped=true"
import script from "./addAttendanceClasses.vue?vue&type=script&lang=js"
export * from "./addAttendanceClasses.vue?vue&type=script&lang=js"
import style0 from "./addAttendanceClasses.vue?vue&type=style&index=0&id=5fa3a798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3a798",
  null
  
)

export default component.exports